// removed by extract-text-webpack-plugin
module.exports = {"root":"product-picker--root--2LpOp5Dm","product-selection":"product-picker--product-selection--2_cH543f","productSelection":"product-picker--product-selection--2_cH543f","select-group":"product-picker--select-group--xmlFmIlr","selectGroup":"product-picker--select-group--xmlFmIlr","select":"product-picker--select--32gM3etM","select-label":"product-picker--select-label--Eiz2D9Gq","selectLabel":"product-picker--select-label--Eiz2D9Gq"};


//////////////////
// WEBPACK FOOTER
// ./components/product-picker/styles.css
// module id = ./components/product-picker/styles.css
// module chunks = 0